import { z } from 'zod';
import { api } from '../lib/http';

/**
 * Vouchers do painel (SPEC §8). O serviço da API devolve datas como `Date` →
 * ISO string no JSON; aceitamos ambos por segurança.
 */
const voucherSchema = z
  .object({
    id: z.string(),
    voucherCodigo: z.string(),
    clienteId: z.string(),
    clienteNome: z.string(),
    indicacaoId: z.string(),
    papel: z.enum(['indicador', 'indicado']).nullable(),
    nivel: z.number().int().nullable(),
    descricao: z.string(),
    status: z.enum(['disponivel', 'entregue']),
    concedidoEm: z.union([z.string(), z.date()]).transform(String),
    entregueEm: z
      .union([z.string(), z.date(), z.null()])
      .transform((v) => (v == null ? null : String(v))),
    retiradoPor: z.string().nullable(),
  })
  .passthrough();
export type Voucher = z.infer<typeof voucherSchema>;

const listaSchema = z.object({ itens: z.array(z.unknown()) });

/** `GET /v1/vouchers?codigo=` — busca por `voucherCodigo` (a API resolve caixa). */
export async function buscarVoucherPorCodigo(codigo: string): Promise<Voucher | null> {
  const bruto = await api(listaSchema, `/v1/vouchers?codigo=${encodeURIComponent(codigo)}`);
  const itens = z.array(voucherSchema).parse(bruto.itens);
  return itens[0] ?? null;
}

export async function obterVoucher(id: string): Promise<Voucher> {
  return api(voucherSchema, `/v1/vouchers/${id}`);
}

const entregaRespostaSchema = z.object({ entregaId: z.string(), voucher: voucherSchema });

/**
 * `POST /v1/vouchers/:id/entregar` — registra a entrega ao portador. 409
 * `voucher_ja_entregue` (`detalhes: { entregueEm, retiradoPor }`) se já retirado.
 */
export function entregarVoucher(id: string, retiradoPor: string) {
  return api(entregaRespostaSchema, `/v1/vouchers/${id}/entregar`, {
    method: 'POST',
    body: { retiradoPor },
  });
}
